var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoadingFullscreen',{attrs:{"description":'Aguarde, estamos processando seu pedido',"image":_vm.AppConfig.assets.images.splash}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }